import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-reset-password',
    imports: [FormsModule, RouterLink],
    templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent {
  private http = inject(HttpClient);
  private router = inject(Router);

  email = '';
  loading = false;

  async resetNow(): Promise<void> {
    this.loading = true;
    try {
      await firstValueFrom(
        this.http.post(`${environment.apiBaseUrl}/user/reset`, { email: this.email })
      );
      this.router.navigate(['/login']);
    } catch {
    } finally {
      this.loading = false;
    }
  }
}
